// Dev-only look-and-feel harness ribbon for the win-back page
// (/win-back/preview). Lets us exercise the page's rental-type / payment /
// state / alternatives permutations via query params without a live token.
// English-only internal tooling — deliberately not translated (this file lives
// under src/components/dev/**, the i18n allowlist's English-only dev carve-out).

export function WinBackPreviewRibbon() {
  const link = (label: string, qs: string) => (
    <a href={`?${qs}`} className="underline hover:no-underline">
      {label}
    </a>
  );
  return (
    <div className="mb-6 rounded-md border border-dashed border-amber-400 bg-amber-50 px-4 py-3 text-xs text-amber-900">
      <span className="font-semibold uppercase tracking-wider">Preview</span>
      <span className="ml-3">Rental: {link("driving", "rental_type=driving")} · {link("chauffeured", "rental_type=chauffeured")} · {link("event", "rental_type=event")}</span>
      <span className="ml-3">Payment: {link("hold", "variant=hold")} · {link("charge", "variant=charge")}</span>
      <span className="ml-3">State: {link("active", "state=active")} · {link("expired", "state=expired")} · {link("converted", "state=converted")}</span>
      <span className="ml-3">Alts: {link("3", "alts=3")} · {link("2", "alts=2")} · {link("0", "alts=0")}</span>
    </div>
  );
}
